// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scriptId: __t.u64().primaryKey().name("script_id"),
  worldId: __t.u64().name("world_id"),
  name: __t.string(),
  source: __t.string(),
  enabled: __t.bool(),
  updatedBy: __t.identity().name("updated_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
